export default "__VITE_ASSET__BDCAjkbO__"